import { appConfig } from "../config";
import type { CountryRow } from "./types";

export interface PrizePool {
  playerCount: number;
  total: number;
}

export function calculatePrizePool(
  countries: CountryRow[],
  perPlayerEur: number = appConfig.winnerLotteryEntryFeeEur,
): PrizePool {
  const players = new Set<string>();

  countries.forEach((country) => {
    const name = country.assignedTo?.trim().toLowerCase();
    if (name) players.add(name);
  });

  const playerCount = players.size;
  return { playerCount, total: playerCount * perPlayerEur };
}
